import Swal from 'sweetalert2/dist/sweetalert2.js'
import * as Sentry from '@sentry/browser'
/**
 * put this function in your catch to log the error to the console, report it to sentry and notify the user with a friendly message
 *
 * usage
 *
 * try { throw Error('bad')} catch (err) { await errorNotifier(err, 'Hi user, we have a problem.') }
 */
async function errorNotifier (error, userMessage) {
  Sentry.captureException(error)
  console.error(error)
  return Swal.fire({
    title: 'Error',
    text: userMessage || error.message,
    icon: 'error'
  })
}

export default errorNotifier
